<div
  class="form-field"
  (mouseenter)="state = 0"
  (mouseleave)="state = 1"
  [ngClass]="{
    'form-field--success': color() === 'success',
    'form-field--error': color() === 'error' || hasErrors,
    'form-field--white': color() === 'white',
    'form-field--default': variant() === 'default',
  }"
  [class.active]="showMenu">
  @if (loadingService.loading()) {
    <ngx-skeleton-loader
      [count]="1"
      [theme]="{
        'border-radius': '.5em',
        width: '5em',
        height: '1em',
        margin: '0',
      }"></ngx-skeleton-loader>
  }
  @if (label()) {
    <label class="form-field__label" [class.!hidden]="loadingService.loading()">
      {{ label() | translate }}
      @if (hasRequiredValidator) {
        <span class="form-field__required">*</span>
      }
    </label>
  }

  @if (loadingService.loading()) {
    <ngx-skeleton-loader
      [count]="1"
      [theme]="{
        'border-radius': '.5em',
        width: '100%',
        height: '2.75em',
        margin: '0',
      }"></ngx-skeleton-loader>
  }
  <button
    [disabled]="disabled"
    id="select-btn"
    type="button"
    [class.form-field__button]="!hasCountryFlag()"
    [class.form-field__button-flag]="hasCountryFlag()"
    [class.!hidden]="loadingService.loading()"
    [ngClass]="{
      'button__has-icon': icon(),
      'button__has-not-icon': !icon(),
      'border-gray-600': selectedOption || selectedOptions.length > 0,
      'border-gray-300': !selectedOption || selectedOptions.length <= 0,
    }"
    (click)="showMenu = !showMenu">
    <div
      class="overflow-hidden overflow-ellipsis whitespace-nowrap text-start"
      [ngClass]="{ 'w-10/12': !hasCountryFlag() }"
      [class.form-field__selected-texts]="
        selectedOption || selectedOptions.length > 0
      ">
      @if (!hasCountryFlag()) {
        @if (multiSelect()) {
          @for (selected of selectedOptions; track selected) {
            {{ selected.label | translate }},
          } @empty {
            {{ placeholder() | translate }}
          }
        } @else {
          {{ selectedOptionFn() || placeholder() | translate }}
        }
      } @else {
        <i [class]="'mx-4 flags flag:' + selectedOptionFn().split('+')[0]"></i>
      }
    </div>
    @if (!hideExpandIcon()) {
      <i
        [class.form-field__selected-texts]="
          selectedOption || selectedOptions.length > 0
        "
        class="iconsax form-field__expand-icon"
        [attr.icon-name]="showMenu ? 'chevron-up' : 'chevron-down'"></i>
    }
  </button>
  @if (hasErrors) {
    <div
      class="form-field__select-errors"
      [class.!hidden]="loadingService.loading()">
      @for (error of messages() | keyvalue; track error) {
        @if (getErrors?.[error.key]) {
          <span class="form-field__select-error">{{
            error.value | translate
          }}</span>
        }
      }
    </div>
  }
  <!-- left icon -->
  @if (icon() && iconPosition() === 'left') {
    <i
      class="iconsax field-left-icon"
      [class.text-gray-600]="!selectedOption || selectedOptions.length <= 0"
      [class.text-primary-dark]="selectedOption || selectedOptions.length > 0"
      [class.!hidden]="loadingService.loading()"
      [attr.icon-name]="icon()"></i>
  }
  <!-- right icon -->
  @if (icon() && iconPosition() === 'right') {
    <i
      class="iconsax field-right-icon"
      [class.text-gray-600]="!selectedOption || selectedOptions.length <= 0"
      [class.!hidden]="loadingService.loading()"
      [class.text-primary-dark]="selectedOption || selectedOptions.length > 0"
      [attr.icon-name]="icon()"></i>
  }
  <div
    class="form-field__select custom-scrollbar"
    [class.form-field__select--flag]="hasCountryFlag()"
    [class.show]="showMenu"
    [class.!hidden]="loadingService.loading()"
    [ngClass]="{ 'top-60': !label(), 'top-80': label() }">
    @if (hasSearch()) {
      <pwj-input
        class="form-field__search"
        [(ngModel)]="searchTerm"
        placeholder="global.search"
        icon="search-normal-2"></pwj-input>
    }
    @for (option of filteredOptions; track option; let i = $index) {
      <a
        class="form-field__item"
        [class.form-field__item--flag]="hasCountryFlag()"
        (click)="valueChange(option)"
        [class.active]="
          selectedOption === option.value ||
          selectedOptions.indexOf(option) !== -1
        ">
        @if (!hasCountryFlag()) {
          {{ option.label | translate }}
        } @else {
          <div class="form-field__item-flag-text">
            <i [class]="'flags flag:' + option.label.split('+')[0]"></i>
            <span>{{ option.label.split('+')[1] }}</span>
          </div>
          <span>+{{ option.label.split('+')[2] }}</span>
        }
      </a>
    } @empty {
      <span class="form-field__item-flag-text">
        {{ 'global.noResult' | translate }}
      </span>
    }
  </div>
</div>
